import { Controller } from "@hotwired/stimulus";

// Champ pays du scan d'éligibilité : saisie libre avec suggestions (<datalist>),
// mais seul un pays de la liste est accepté.
//
// Le texte tapé n'est pas envoyé : le code alpha-2 du pays reconnu part dans le
// champ caché. Tant que le texte ne correspond à aucun pays, le champ visible
// porte une erreur de validation — le navigateur refuse l'envoi et l'affiche.
export default class extends Controller {
  static targets = ["input", "code"];
  static values = { invalid: String };

  connect() {
    this.#validate();
  }

  // À chaque frappe : un choix dans les suggestions arrive ici avec le libellé
  // complet. Pas de complétion automatique pendant la frappe, elle couperait
  // la saisie sous les doigts.
  sync() {
    this.codeTarget.value = this.#exactMatch()?.code ?? "";
    this.#validate();
  }

  // En sortie de champ : un début de nom sans ambiguïté (« allem ») vaut choix.
  settle() {
    const match = this.#exactMatch() ?? this.#uniquePrefixMatch();
    if (match) {
      this.inputTarget.value = match.name;
      this.codeTarget.value = match.code;
    }
    this.#validate();
  }

  // Code posé de l'extérieur (pré-remplissage SIRET) : on affiche son libellé.
  fromCode() {
    const match = this.#countries().find((country) => country.code === this.codeTarget.value);
    this.inputTarget.value = match?.name ?? "";
    this.#validate();
  }

  #validate() {
    const invalid = this.inputTarget.value.trim() !== "" && this.codeTarget.value === "";
    this.inputTarget.setCustomValidity(invalid ? this.invalidValue : "");
  }

  #exactMatch() {
    const typed = normalize(this.inputTarget.value);
    if (!typed) return null;

    return this.#countries().find((country) => country.key === typed) ?? null;
  }

  #uniquePrefixMatch() {
    const typed = normalize(this.inputTarget.value);
    if (!typed) return null;

    const matches = this.#countries().filter((country) => country.key.startsWith(typed));
    return matches.length === 1 ? matches[0] : null;
  }

  #countries() {
    if (!this.countries) {
      const list = document.getElementById(this.inputTarget.getAttribute("list"));
      this.countries = Array.from(list?.options ?? []).map((option) => ({
        name: option.value,
        code: option.dataset.code,
        key: normalize(option.value),
      }));
    }
    return this.countries;
  }
}

// Insensible à la casse et aux accents : « aland » trouve « Åland, Îles ».
function normalize(value) {
  return value.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().trim();
}
